<template>
  <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-dark" id="sidebar">
    <div class="container-fluid">
      <!-- Toggler -->
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#sidebarCollapse" aria-controls="sidebarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Brand -->
      <div class="navbar-brand">
        <img src="~assets/img/logo/nsw-light.svg" class="navbar-brand-img" alt="NSW Government" />
      </div>

      <!-- Collapse -->
      <div class="collapse navbar-collapse" id="sidebarCollapse">
        <!-- Navigation -->
        <ul class="navbar-nav">
          <router-link :to="{ name: 'dashboard' }" tag="li" class="nav-item" :class="[activeRoute('dashboard')]">
            <a class="nav-link">
              <font-awesome :icon="['fal', 'home-lg-alt']"/> Home
            </a>
          </router-link>

          <router-link :to="{ name: 'placements' }" tag="li" v-if="$userIsGraduate" class="nav-item" :class="[activeRoute('placements')]">
            <a class="nav-link">
              <font-awesome :icon="['fal', 'calendar-alt']"/> Placements
            </a>
          </router-link>

          <router-link v-if="!$userIsGraduate" :to="{ name: 'graduates' }" tag="li" class="nav-item" :class="[activeRoute('graduates')]">
            <a class="nav-link">
              <font-awesome :icon="['fal', 'users']"/> Graduates
            </a>
          </router-link>

          <router-link tag="li" class="nav-item" v-if="$userIsAdmin || $userIsCoordinator" :to="{ name: 'programs' }">
            <a class="nav-link">
              <font-awesome :icon="['fal', 'clipboard-list-check']"/> Programs
            </a>
          </router-link>

          <router-link tag="li" v-if="$userIsAdmin || $userIsCoordinator" :to="{ name: 'reports' }" class="nav-item" :class="[activeRoute('reports')]">
            <a class="nav-link">
              <font-awesome :icon="['fal', 'file-chart-line']"/> Reports
            </a>
          </router-link>

          <router-link v-if="$userIsAdmin || $userIsCoordinator" :to="{ name: 'agencies' }" tag="li" class="nav-item" :class="[activeRoute('agencies')]">
            <a class="nav-link">
              <font-awesome :icon="['fal', 'city']"/> Agencies
            </a>
          </router-link>

          <router-link v-if="$userIsAdmin" :to="{ name: 'users' }" tag="li" class="nav-item" :class="[activeRoute('users')]">
            <a class="nav-link">
              <font-awesome :icon="['fal', 'id-card']"/> Users
            </a>
          </router-link>

          <router-link :to="{ name: 'account' }" tag="li" class="nav-item" :class="[activeRoute('account')]">
            <a class="nav-link">
              <font-awesome :icon="['fal', 'user-circle']"/> My Account
            </a>
          </router-link>
          <li class="nav-item" v-if="userHelpRoute">
            <a class="nav-link" target="_blank" :href="userHelpRoute">
              <font-awesome :icon="['far', 'question-circle']"/> Help & Resources
            </a>
          </li>
        </ul>
      </div> <!-- / .navbar-collapse -->
    </div>
  </nav>
</template>

<script>
import { startsWith } from 'lodash'
export default {
  methods: {
    activeRoute (name) {
      if (startsWith(this.$route.name, name)) {
        return 'active'
      }
    }
  },
  computed: {
    userHelpRoute () {
      if (this.$user.help_link && this.$user.help_link.length > 0) {
        return this.$user.help_link
      }
      return false
    }
  }
}
</script>
